import type { ReactNode } from "react";

interface TabPanelProps {
  loading?: boolean;
  error?: string | null;
  empty?: boolean;
  emptyMessage?: string;
  children?: ReactNode;
}

/**
 * Standard wrapper for focus-mode tab bodies. Owns the loading / error /
 * empty / content state machine so every tab renders consistently.
 *
 * Each tab component should call its own data hook, then pass its loading
 * and error state to this wrapper. Tabs without data (like Overview) can
 * skip these props entirely.
 */
export function TabPanel({
  loading,
  error,
  empty,
  emptyMessage = "Nothing here yet.",
  children,
}: TabPanelProps) {
  if (loading) {
    return <div className="tab-content tab-content-loading">LOADING…</div>;
  }
  if (error) {
    return (
      <div className="tab-content tab-content-placeholder">⚠ {error}</div>
    );
  }
  if (empty) {
    return (
      <div className="tab-content tab-content-placeholder">{emptyMessage}</div>
    );
  }
  return <div className="tab-content">{children}</div>;
}
